import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, Users } from 'lucide-react';

export const CircleHeader = ({ stats }) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center justify-between mb-6">
      <button
        onClick={() => navigate('/sanctuary')}
        className="flex items-center gap-2 transition-opacity hover:opacity-70"
        style={{ color: '#4A4A5A', fontFamily: 'Jost, sans-serif' }}
        data-testid="back-to-sanctuary"
      >
        <ChevronLeft className="w-5 h-5" />
        Sanctuary
      </button>
      
      {stats && (
        <div 
          className="flex items-center gap-2 px-3 py-1.5 rounded-full"
          style={{ background: 'rgba(201,168,76,0.1)' }}
        >
          <Users className="w-4 h-4" style={{ color: '#C9A84C' }} />
          <span 
            className="text-sm"
            style={{ color: '#C9A84C', fontFamily: 'Jost, sans-serif' }}
          >
            {stats.active_members} members
          </span>
        </div>
      )}
    </div>
  );
};
